import { render, staticRenderFns } from "./FileInbox.vue?vue&type=template&id=7f4a0ac4&scoped=true"
import script from "./FileInbox.vue?vue&type=script&lang=ts"
export * from "./FileInbox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4a0ac4",
  null
  
)

export default component.exports